import { Box, type SxProps, type Theme } from '@mui/material';
import React from 'react';

import OnboardingStepPasswordImage from '../../assets/onboarding/onboarding-step-password.svg';
import { spaces } from '../../assets/styles/themes/tokens';
import FormContainer from '../../routes/onboarding/FormContainer';
import useScreenSize from '../../utils/useScreenSize';
import OnboardingStepImage from '../onboarding/OnboardingStepImage';

interface PageContainerProps {
	children: React.ReactNode;
	pageBodySx?: SxProps<Theme>;
}

const PageContainer = ({ children, pageBodySx }: PageContainerProps) => {
	const { isXsScreen } = useScreenSize();

	return (
		<Box
			data-testid="login-flow-page-conteiner"
			sx={{
				display: 'flex',
				width: '100%',
				minHeight: '100vh',
				justifyContent: 'center',
				overflow: 'hidden',
			}}
		>
			<FormContainer isLoginPage>
				<Box
					data-testid="login-flow-page-content"
					sx={{
						width: '100%',
						height: '100%',
						overflowY: 'auto',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Box
						data-testid="page-body"
						sx={{
							height: '100%',
							maxWidth: isXsScreen ? '100%' : undefined,
							minWidth: isXsScreen ? undefined : '600px',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
							paddingX: isXsScreen ? 0 : spaces.xxxxl,
							gap: spaces.xxxl,
							...pageBodySx,
						}}
					>
						{children}
					</Box>
				</Box>
			</FormContainer>
			<OnboardingStepImage stepImage={<OnboardingStepPasswordImage />} />
		</Box>
	);
};

export default PageContainer;
